import { render, staticRenderFns } from "./RolesEdit.vue?vue&type=template&id=306f6ed4&scoped=true"
import script from "./RolesEdit.vue?vue&type=script&lang=js"
export * from "./RolesEdit.vue?vue&type=script&lang=js"
import style0 from "./RolesEdit.vue?vue&type=style&index=0&id=306f6ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306f6ed4",
  null
  
)

export default component.exports